import { type FC, useCallback } from "react";

import { Button } from "@snapchat/snap-design-system";
import { AddIcon } from "@snapchat/snap-design-system-icons";

import { type Discoverability } from "../../gql-generated/types";
import { Flexbox, LabelWithTooltip } from "../../shared/components";
import { useToggleState } from "../../shared/hooks";

import { LensDiscoverabilityModal } from "./LensDiscoverabilityModal";
import { labelWithTooltipStyles } from "./LensDiscoverabilityTagsRow.styles";
import {
    LensDiscoverabilityAddTags,
    LensDiscoverabilityLabel,
    LensDiscoverabilityRowTooltip,
} from "./messages.generated";

interface LensDiscoverabilityTagsRow {
    lensOrSubmissionId: string;
    discoverability: Discoverability | null;
    setDiscoverability: (lensDiscoverabilityTags: Discoverability | null) => void;
}

// TODO(scao): WIP
export const LensDiscoverabilityTagsRow: FC<LensDiscoverabilityTagsRow> = ({
    lensOrSubmissionId,
    discoverability,
    setDiscoverability,
}) => {
    const [{ visible, onCancel }, showModal] = useToggleState();
    const onSave = useCallback(
        (discoverability: Discoverability) => {
            setDiscoverability(discoverability);
            onCancel();
        },
        [onCancel, setDiscoverability],
    );

    return (
        <>
            <Flexbox justifyContent="space-between" alignItems="center">
                <LabelWithTooltip
                    className={labelWithTooltipStyles}
                    label={<LensDiscoverabilityLabel />}
                    content={<LensDiscoverabilityRowTooltip />}
                />
                <Button size="small" onClick={showModal}>
                    <AddIcon />
                    <span>
                        <LensDiscoverabilityAddTags />
                    </span>
                </Button>
            </Flexbox>
            <LensDiscoverabilityModal
                lensOrSubmissionId={lensOrSubmissionId}
                discoverability={discoverability}
                visible={visible}
                onSave={onSave}
                onCancel={onCancel}
                saveLoading={false}
            />
        </>
    );
};
